import React from "react";
import { TextInputProps } from "../../types/screensTypes";
import styles from "./TextInput.module.css";

const sizeClass: Record<NonNullable<TextInputProps["size"]>, string> = {
    small: styles.small,
    medium: styles.medium,
    big: styles.big,
    "big-with-border": styles.bigWithBorder,
};

const TextInput: React.FC<TextInputProps> = ({
    placeholder = "",
    size = "small",
    value,
    onChange,
    isMissing = false,
    numberOfLines = 25,
    onKeyDown,
    onKeyPress,
    type = "text",
    disabled = false,
    style,
    onBlur,
    name,
    customClassName,
    fullWidth = false,
    autoFocus = false,
}) => {
    // Keep legacy size class names for ExperienceFlow / theme selectors during migration
    const legacySize = `text-input-${size}`;
    const className = [
        sizeClass[size] || styles.small,
        legacySize,
        isMissing ? `${styles.missing} text-missing` : "",
        fullWidth || customClassName?.includes("text-input-fluid") ? styles.fluid : "",
        customClassName ?? "",
    ]
        .filter(Boolean)
        .join(" ");

    const shared = {
        className,
        placeholder,
        value,
        onChange,
        onKeyDown,
        onKeyPress,
        disabled,
        style,
        onBlur,
        name,
        autoFocus,
        "data-rw-control": "text-input" as const,
    };

    return size === "big" || size === "big-with-border" ? (
        <textarea {...shared} rows={numberOfLines} />
    ) : (
        <input {...shared} type={type} />
    );
};

export default TextInput;
